import script from "./MainAll.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainAll.vue?vue&type=script&setup=true&lang=ts"

import "./MainAll.vue?vue&type=style&index=0&id=9843c72a&lang=scss&scoped=true"

import exportComponent from "/home/matriXagent/git/center-secure/product/ap/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9843c72a"]])

export default __exports__